import { useTranslation } from "react-i18next";
import SideBarItemList from "../../../components/uiPartials/sidebar/SideBarItemList";
import SolarTestTubeLinear from "./SolarTestTubeLinear";
import "../i18n";

const RedgerlabSideBarMenu = () => {
    const { t } = useTranslation(["Redgerlab", "common"]);
    return (
        <SideBarItemList
            title={t("sideTitle")}
            icon={(<SolarTestTubeLinear />)}
            itemsList={[
                {
                    label: t("sideItemPatients"),
                    to: "/redgerlab/patients",
                    startsWith: "/redgerlab/patients",
                },
            ]}
        />
    );
};

export default RedgerlabSideBarMenu;
